import { OrganizerAction, OrganizerActionType } from '../actions/organizer';
import { OrganizerNamespace } from '../state/organizer';

export const organizerReducer = (
    state: OrganizerNamespace = {
        enableOrganizerMarketingOptIn: false,
        logoUrl: null,
        name: null,
        url: null,
        followedByYou: false,
        numFollowers: 0,
    },
    action: OrganizerAction,
) => {
    switch (action.type) {
        case OrganizerActionType.setOrganizerMarketingOptIn:
            return {
                ...state,
                enableOrganizerMarketingOptIn: action.payload,
            };

        case OrganizerActionType.setOrganizerNameAndLogo:
            return {
                ...state,
                logoUrl: action.payload.logoUrl,
                name: action.payload.name,
            };

        case OrganizerActionType.setOrganizerUrlAndFollowers:
            return {
                ...state,
                url: action.payload.url,
                followedByYou: action.payload.followedByYou,
                numFollowers: action.payload.numFollowers,
            };

        default:
            return state;
    }
};
